import { countryFlagCodes } from "~/client/features/emoji/countryFlagCodes";
import { unicode150Codes } from "~/client/features/emoji/unicode150Codes";
import { isDarwin } from "~/client/utils/isDarwin";
import { isChrome, isEdge, isFirefox, isLinux, isWindows10Or11 } from "~/client/utils/platform";

export class UnicodeEmoji {
  emojiCode: string;

  // @param emojiCode 絵文字コード (例: ":smile:")
  constructor(emojiCode: string) {
    this.emojiCode = emojiCode;
  }

  isCountryFlag() {
    return countryFlagCodes.includes(this.emojiCode);
  }

  isUnicode150() {
    return unicode150Codes.includes(this.emojiCode);
  }

  getClassNames() {
    const classNames = ["unicode-emoji"];
    const classNamesWithNoto = ["unicode-emoji", "with-noto"];

    if (isDarwin) {
      return classNames;
    }

    // Windows 10, 11ではSegoe UI Emojiフォントを使用する
    // https://learn.microsoft.com/ja-jp/typography/font-list/segoe-ui-emoji
    if (isWindows10Or11) {
      if (isChrome || isEdge) {
        // 国旗がうまく表示されない問題の対応
        // ref: https://bitjourney.kibe.la/notes/30565
        if (!this.isCountryFlag()) {
          return classNames;
        }
      } else {
        return classNames;
      }
    }

    if (isLinux) {
      if (isFirefox) {
        // Unicode 15.0から追加された絵文字がうまく表示されない問題の対応
        // ref: https://bitjourney.kibe.la/notes/30566
        if (!this.isUnicode150()) {
          return classNames;
        }
      } else {
        return classNames;
      }
    }

    return classNamesWithNoto;
  }

  getClassName() {
    return this.getClassNames().join(" ");
  }
}
